<script>
export default {
  server:'https://sttaa.seed.web.id/api/v2',
//  images_url:'https://gky.seed.web.id/a7c7cc31b2462/images',
//  server:'http://10.0.0.2:57744/api/v2',
//  server:'http://192.168.250.1:57744/api/v2',
//  images_url:'http://localhost:5744/images',
  categories:[
       { value: 11, text:'ANGGOTA GKY', dtype:1 },
       { value: 12, text:'NON ANGGOTA GKY', dtype:1 },
       { value: 13, text:'NN QRIS', dtype:1 },
       { value: 14, text:'NN TUNAI', dtype:1 },
       { value: 15, text:'NN LAINNYA', dtype:1 },
       { value: 16, text:'KOMUNITAS STTAA', dtype:1 },
       { value: 19, text:'TIDAK ADA DATA', dtype:1 },
       { value: 1, text:'GEREJA GKY', dtype:0 },
       { value: 2, text:'GEREJA Lain', dtype:0 },
       { value: 3, text:'INSTITUSI/YAYASAN', dtype:0 },
       { value: 99, text:'DPMT', dtype:2 },
  ],
  dtypes:[
       { value: 0, text:'Organisasi' },
       { value: 1, text:'Individu' },
       { value: 2, text:'Khusus' },
  ],
  genders:[
       { value: '0', text:'Wanita' },
       { value: '1', text:'Pria' },
       { value: '2', text:'Tidak ada' },
  ],
  fonts:[ 
       {value:'arimo', text:'Arial'},
       {value:'arimo_b', text:'Arial Bold'},
       {value:'cormorantinfant_sb', text:'Cormorant Infant'},
       {value:'dancingscript_m', text:'Dancing Script'},
       {value:'eduauvicwanthand_r', text:'Edu Au Vic Want Hand'},
       {value:'italianno', text:'Italianno'},
       {value:'meaculpa', text:'Meaculpa'},
       {value:'nimbus', text:'Times New Roman'},
       {value:'pacifico', text:'Pacifico'},
       {value:'sroboto_r', text:'Sroboto'},
  ]
};
</script>
